//not sure if we need to move this to common library. let's just leave here for now
export const CPP_NAME_SHORT = 'CPP-D';
export const CPP_NAME_LONG = `Canada Pension Plan - Disability`;
export const CPP_NAME_COMBINED = `${CPP_NAME_LONG} (${CPP_NAME_SHORT})`;

export const CRA_NAME_SHORT = 'CRA';
export const CRA_NAME_LONG = 'Canada Revenue Agency';
